import {
  AfterViewInit,
  Component,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

import { NotificationsService } from '../shared/services/notifications.service';

@Component({
  selector: 'ldm-non-authenticated',
  templateUrl: './non-authenticated.component.html',
  styleUrls: ['./non-authenticated.component.scss'],
})
export class NonAuthenticatedComponent implements AfterViewInit {
  @ViewChild('notificationContainer', { read: ViewContainerRef })
  public container!: ViewContainerRef;

  options: AnimationOptions = {
    path: '/assets/animations/login.json',
    loop: true,
  };

  constructor(private readonly notificationService: NotificationsService) {}

  ngAfterViewInit(): void {
    this.notificationService.setContainer(this.container);
  }
}
